module.exports = __webpack_public_path__ + "assets/instagram-dark.414ae0ec.svg";